import i18n from '../i18n';

import {jwtDecode} from 'jwt-decode';
import log from 'loglevel';
import React from 'react';
import Smartlook from 'smartlook-client';

log.setLevel('debug');

export const makeUppercaseUnderscoreSeparated = (data) => {
  data += '';
  return data.split(' ').join('_').toUpperCase();
};

export const makeUppercaseUnderscoreSeparatedAndRemoveDot = (data) => {
  data += '';
  return data.replace('.', '').split(' ').join('_').toUpperCase();
};

export const sleep = async (secs) =>
  await new Promise((r) => setTimeout(r, secs * 1000));

export const getYearOptions = (
  fromYear,
  toYear = new Date().getFullYear(),
  showAll
) => {
  let allYearOptions = [];
  showAll && allYearOptions.push(i18n.t('SHOW_ALL'));
  allYearOptions =
    toYear >= new Date().getFullYear()
      ? [...allYearOptions, toYear]
      : [...allYearOptions, new Date().getFullYear(), toYear];
  let currYear = toYear;
  while (currYear !== fromYear) allYearOptions.push(--currYear);
  return allYearOptions;
};

export const getFormattedDate = (date) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  let enteredDate = new Date(date);
  let dd = String(enteredDate.getDate()).padStart(2, '0');
  let mm = monthNames[enteredDate.getMonth()];
  let yyyy = enteredDate.getFullYear();

  let formattedDate = dd + '-' + mm + '-' + yyyy;
  return formattedDate;
};

export const createTraceId = (customerId) => {
  return new Promise((resolve) => {
    const traceId = getFormatedDateTime() + '__' + customerId;
    localStorage.setItem('trace-id', traceId);
    resolve();
  });
};
export const deleteTraceId = () => {
  localStorage.removeItem('trace-id');
};

export const amountFormatter = (amount) =>
  parseFloat(amount).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const getFormatedDateTime = () => {
  const date = new Date();
  return (
    date.getFullYear() +
    '/' +
    ('00' + (date.getMonth() + 1)).slice(-2) +
    '/' +
    ('00' + date.getDate()).slice(-2) +
    ' ' +
    ('00' + date.getHours()).slice(-2) +
    ':' +
    ('00' + date.getMinutes()).slice(-2) +
    ':' +
    ('00' + date.getSeconds()).slice(-2)
  );
};

export const getFormattedLongDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const options = {day: 'numeric', month: 'long', year: 'numeric'};
  return date.toLocaleDateString('en-IN', options);
};

export const calculateNoOfDays = (date) => {
  if (date) {
    const today = new Date();
    const date_to_reply = new Date(date);
    const timeinmilisec = date_to_reply.getTime() - today.getTime();
    const noOfDaysRemaining = Math.ceil(timeinmilisec / (1000 * 60 * 60 * 24));
    return noOfDaysRemaining;
  }
};

export const capitalizeFirstName = (name) => {
  const firstName = name.split(' ')[0];
  const capitalizedName =
    firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
  return capitalizedName;
};

export const formatNames = (name) => {
  if (typeof name !== 'string') {
    return name;
  }
  const words = name.split('_');
  const formattedName = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  return formattedName;
};

export const checkNonMfaTokenValidity = () => {
  const token = sessionStorage.getItem('nonMFAToken');
  if (token) {
    return JSON.parse(token).nonMFATokenExpiry > new Date().getTime();
  }
  return false;
};

export const getNonMfaCustomerPhoneNumber = () => {
  try {
    const sessionDataStr = sessionStorage.getItem('nonMFAToken');
    if (!sessionDataStr) return '';

    const sessionData = JSON.parse(sessionDataStr);
    const nonMfaToken = sessionData?.nonMFAToken;

    if (nonMfaToken) {
      const decodedToken = jwtDecode(nonMfaToken);
      return extractPhoneDigits(decodedToken?.phoneNumber);
    }

    return sessionData?.phoneNumber || '';
  } catch (error) {
    return '';
  }
};

export const setSubmittedOffersIdInSession = (offerId) => {
  let submittedOffers = sessionStorage.getItem('submittedOffers');

  if (submittedOffers) {
    submittedOffers = JSON.parse(submittedOffers);
    submittedOffers.push(offerId);
  } else {
    submittedOffers = [offerId];
  }
  sessionStorage.setItem('submittedOffers', JSON.stringify(submittedOffers));
};

export const getSubmittedOffersIdFromSession = () => {
  let submittedOffersIdList = sessionStorage.getItem('submittedOffers');
  if (submittedOffersIdList) {
    return JSON.parse(submittedOffersIdList);
  }
  return [];
};

export const encodeToBase64 = (text) => {
  try {
    if (!text) {
      log.debug('encodeToBase64: Input text is null or undefined');
      return '';
    }
    return btoa(text);
  } catch (error) {
    log.debug('Error encoding to base64:', error.message);
    return '';
  }
};

export async function hash(string) {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
}

export const callNumber = (number) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({number}));
  }
};

export const PAGE_ACTION = {
  OOPS: 'OOPS',
  SPECIAL_OFFER_SUBMITTED: 'SPECIAL_OFFER_SUBMITTED',
  SPECIAL_OFFER_DETAILS: 'SPECIAL_OFFER_DETAILS',
  SPECIAL_OFFER_PAGE: 'SPECIAL_OFFER_PAGE',
  OFFER_SUBMIT_FORM: 'OFFER_SUBMIT_FORM',
  OFFER_MOBILE_VERIFICATION: 'OFFER_MOBILE_VERIFICATION',
  OFFER_ENQUIRY_ERROR: 'OFFER_ENQUIRY_ERROR',
  OFFER_ENQUIRY_SUBMITTED: 'OFFER_ENQUIRY_SUBMITTED',
  OFFER_CATEGORY_PAGE: 'OFFER_CATEGORY_PAGE',
  OFFER_DETAILS_PAGE: 'OFFER_DETAILS_PAGE',
  OFFER_LIST_PAGE: 'OFFER_LIST_PAGE',
  LOGIN_PAGE: 'LOGIN_PAGE',
  CLIENT_ID_ENTER: 'CLIENT_ID_ENTER',
  MAINTENANCE_PAGE: 'MAINTENANCE_PAGE',
  OTP_VERIFICATION_PAGE: 'OTP_VERIFICATION_PAGE',
  VERIFY_OTP_CLICK: 'VERIFY_OTP_CLICK',
  VERIFY_OTP_ERROR: 'VERIFY_OTP_ERROR',
  DASHBOARD: 'DASHBOARD',
  SEND_OTP_ERROR: 'SEND_OTP_ERROR',
  LOGIN_ID_ERROR: 'LOGIN_ID_ERROR',
  VERIFY_PASSWORD_ERROR: 'VERIFY_PASSWORD_ERROR',
  PREVIOUS_SUBMITTED_OFFER_PAGE: 'PREVIOUS_SUBMITTED_OFFER_PAGE',
  RESALE_LANDING_PAGE: 'RESALE_LANDING_PAGE',
  RESALE_ITEM_DETAILS: 'RESALE_ITEM_DETAILS',
  RESALE_ITEM_ENQUIRY: 'RESALE_ITEM_ENQUIRY',
  DIWALI_GREETING_SEEN: 'DIWALI_GREETING_SEEN',
  DIWALI_GREETING_CLOSED: 'DIWALI_GREETING_CLOSED',
  DIWALI_GREETING_OPEN: 'DIWALI_GREETING_OPEN',
  NOTIFICATION_ALREADY_ENABLE: 'NOTIFICATION_ALREADY_ENABLE',
  NOTIFICATION_ASKED_CONFIRMATION: 'NOTIFICATION_ASKED_CONFIRMATION',
  NOTIFICATION_USER_CLICK_YES: 'NOTIFICATION_USER_CLICK_YES',
  NOTIFICATION_USER_CLICK_NO: 'NOTIFICATION_USER_CLICK_NO',
  PRE_APPROVED_LANDING_PAGE: 'PRE_APPROVED_LANDING_PAGE',
  PRE_APPROVED_OFFER_ENQUIRY: 'PRE_APPROVED_OFFER_ENQUIRY',
  RC_UPLOAD_PAGE_VISIT: 'RC_UPLOAD_PAGE_VISIT',
  RC_SUBMITTED_WITHOUT_WARNING: 'RC_SUBMITTED_WITHOUT_WARNING',
  RC_SUBMITTED_WITH_WARNING: 'RC_SUBMITTED_WITH_WARNING',
  INVALID_RC_WARNING_SHOWN: 'INVALID_RC_WARNING_SHOWN',
  RC_SUBMISSION_CANCELLED: 'RC_SUBMISSION_CANCELLED',
  WHATSAPP_OPTIN_MODAL_SHOWN: 'WHATSAPP_OPTIN_MODAL_SHOWN',
  WHATSAPP_OPTIN_YES_CLICKED: 'WHATSAPP_OPTIN_YES_CLICKED',
  WHATSAPP_OPTIN_REMIND_LATER_CLICKED: 'WHATSAPP_OPTIN_REMIND_LATER_CLICKED',
  NACH_VISITED: 'NACH_VISITED',
  BURGER_MENU: 'BURGER_MENU',
  SIGN_OUT: 'SIGN_OUT',
  SIGN_OUT_CANCELLED: 'SIGN_OUT_CANCELLED',
  ACCOUNT_SUMMARY: 'ACCOUNT_SUMMARY',
  MAKE_PAYMENT: 'MAKE_PAYMENT',
  CONFIRM_PAYMENT: 'CONFIRM_PAYMENT',
  PENDING_ITEM: 'PENDING_ITEM',
  MY_ACCOUNT: 'MY_ACCOUNT',
  PAYMENT_HISTORY: 'PAYMENT_HISTORY',
  TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
  LOAN_DETAILS: 'LOAN_DETAILS',
  LOAN_SUMMARY: 'LOAN_SUMMARY',
  BANK_DETAILS: 'BANK_DETAILS',
  EQUIPMENTS_INFO: 'EQUIPMENTS_INFO',
  DOWNLOAD_DOCUMENT: 'DOWNLOAD_DOCUMENT',
  DOWNLOAD_RECEIPT: 'DOWNLOAD_RECEIPT',
  REFERRAL_PAGE: 'REFERRAL_PAGE',
  CONTACT_US: 'CONTACT_US',
  PAYMENT_SCHEDULE: 'PAYMENT_SCHEDULE',
  NOTIFICATIONS: 'NOTIFICATIONS',
  RESALE_PAGE_NON_MFA: 'RESALE_PAGE_NON_MFA',
  OFFER_ENQUIRY_FORM: 'OFFER_ENQUIRY_FORM',
  LOCKED_USER_PAGE: 'LOCKED_USER_PAGE',
  EXPIRED_CONTRACT_DETAILS: 'EXPIRED_CONTRACT_DETAILS',
  FILE_UPLOAD_MODAL: 'FILE_UPLOAD_MODAL',
  HOME_PAGE: 'HOME_PAGE',
  LANGUAGE_SELECTOR: 'LANGUAGE_SELECTOR',
  FAQ_PAGE: 'FAQ_PAGE',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_USERNAME: 'FORGOT_USERNAME',
  VERIFY_ACCOUNT_PAGE: 'VERIFY_ACCOUNT_PAGE',
  UNAVAILABLE_CARD: 'UNAVAILABLE_CARD',
  NOTIFICATION_WIDGET: 'NOTIFICATION_WIDGET',
  FAVOURITE_OFFERS: 'FAVOURITE_OFFERS',
  PERSONAL_LETTER_CARD: 'PERSONAL_LETTER_CARD',
  RC_REMINDER: 'RC_REMINDER',
  REGISTRATION_UPDATE: 'REGISTRATION_UPDATE',
  SHARE_WIDGET: 'SHARE_WIDGET',
  TERMS_AND_CONTITIONS: 'TERMS_AND_CONTITIONS',
  FINANCE_OFFER: 'FINANCE_OFFER',
  HOME_TAB: 'HOME_TAB',
  PAYMENT_TAB: 'PAYMENT_TAB',
  TRANSACTION_TAB: 'TRANSACTION_TAB',
  DOCUMENTS_TAB: 'DOCUMENTS_TAB',
  MACHINE_HEALTH_ENQUIRE_CLICK: 'MACHINE_HEALTH_ENQUIRE_CLICK',
  MACHINE_HEALTH_INTRO_CONTINUE: 'MACHINE_HEALTH_INTRO_CONTINUE',
  MACHINE_HEALTH_INTRO_NOT_NOW: 'MACHINE_HEALTH_INTRO_NOT_NOW',
  MACHINE_HEALTH_VIEW_PREVIOUS_OFFERS: 'MACHINE_HEALTH_VIEW_PREVIOUS_OFFERS',
  MACHINE_HEALTH_VIEW_INSIGHTS_CLICK: 'MACHINE_HEALTH_VIEW_INSIGHTS_CLICK',
  PHONE_UPDATE_SEND_OTP: 'PHONE_UPDATE_SEND_OTP',
  PHONE_UPDATE_VERIFY_OTP: 'PHONE_UPDATE_VERIFY_OTP',
  EMAIL_UPDATE_SEND_OTP: 'EMAIL_UPDATE_SEND_OTP',
  EMAIL_UPDATE_VERIFY_OTP: 'EMAIL_UPDATE_VERIFY_OTP',
};

export const logPageActionToNewRelic = (pageName, _extraAttributesObject) => {
  if (window.newrelic && PAGE_ACTION[pageName]) {
    let uniqTraceId = localStorage.getItem('trace-id');
    if (!uniqTraceId) {
      uniqTraceId = `${getFormatedDateTime()}_100`;
    }
    if (uniqTraceId && uniqTraceId.includes('__-404')) {
      _extraAttributesObject.isTestUser = true;
    }
    _extraAttributesObject.traceId = uniqTraceId;
    window.newrelic.addPageAction(
      PAGE_ACTION[pageName],
      _extraAttributesObject
    );
  } else {
    log.debug('new relic not found for action ', pageName);
  }
};

export const logPageActionToSmartlook = (
  pageName,
  extraProperties,
  logError = null
) => {
  let environment = process.env.REACT_APP_ENVIRONMENT;

  if (environment === 'cert' || environment === 'qual') {
    return;
  }
  if (logError && Smartlook) {
    Smartlook.error(logError);
    return;
  }
  if (Smartlook && PAGE_ACTION[pageName]) {
    let uniqTraceId = localStorage.getItem('trace-id');
    if (!uniqTraceId) {
      uniqTraceId = `${getFormatedDateTime()}_100`;
    }
    if (uniqTraceId && uniqTraceId.includes('__-404')) {
      extraProperties = extraProperties || {};
      extraProperties.isTestUser = true;
    }
    extraProperties = extraProperties || {};
    extraProperties.traceId = uniqTraceId;

    Smartlook.track(PAGE_ACTION[pageName], extraProperties);
  } else {
    log.debug('Smartlook not found for action ', pageName);
  }
};

export const identifySmartlookUser = (username) => {
  try {
    const environment = process.env.REACT_APP_ENVIRONMENT;

    if (Smartlook && (environment === 'devl' || environment === 'prod')) {
      Smartlook.identify(encodeToBase64(username), {
        userType: 'authenticated_customer',
      });
    } else {
      log.info(
        `Smartlook identification skipped for environment: ${environment}`
      );
    }
  } catch (error) {
    log.info('Smartlook identification failed:', error);
  }
};

export const OpenWebURL = (key, url) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({[key]: url}));
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

export const postMessageTriggerPushSettingOnMobile = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        openNotificationSetting: true,
      })
    );
  }
};

export const getISOFormattedDate = () =>
  new Date().toISOString().replace('T', ' ').slice(0, 19).replaceAll(/-/g, '/');

export const validateToken = (token, phoneNumber) => {
  try {
    const decodedToken = jwtDecode(token);

    if (decodedToken.exp) {
      const currentTime = Date.now();
      const expiryTime = decodedToken.exp * 1000;

      if (currentTime >= expiryTime) {
        log.info('token has expired');
        return false;
      }
    }

    if (decodedToken.phoneNumber === phoneNumber) {
      return true;
    }

    log.info('phone number does not match token');
    return false;
  } catch (error) {
    log.info('error decoding and validating token:', error.message);
    return false;
  }
};

export const convertUrlsToLinks = (text, options = {}) => {
  if (typeof text !== 'string') return text;
  const {linkText, className = 'link'} = options;
  const urlRegex = /(https?:\/\/[^\s<]+[^\s<.,;:!?)'"\]])/g;
  const parts = text.split(urlRegex);

  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        aria-label={linkText ? `${linkText}: ${part}` : undefined}
      >
        {linkText || part}
      </a>
    ) : (
      part
    )
  );
};

export const redirectChangeEmail = (navigate) => {
  navigate('/changeEmail');
};

export const maskPhoneNumber = (phoneNumber) => {
  const digits = `${phoneNumber || ''}`.replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  return `+91 XXX-XXX-${digits.slice(-4)}`;
};

export const extractPhoneDigits = (phoneNumber) => {
  return `${phoneNumber || ''}`.replace(/\D/g, '').slice(-10);
};

export const maskEmail = (email) => {
  if (!email || !email.includes('@')) {
    return email || '';
  }
  const [localPart, domain] = email.split('@');
  return `${localPart.slice(0, 3)}***@${domain}`;
};
